import React, { useEffect, useRef } from 'react';
import ErrorMessage from './ErrorMessage';

const ErrorMessageList = ({ messages = [] }) => {
    const firstMsgRef = useRef();
    const msgElements = messages.map((message, index) => {
        return <ErrorMessage key={index} message={message.msg} ref={(index === 0) ? firstMsgRef : undefined} />
    });

    useEffect(() => {
        if (firstMsgRef.current) {
            firstMsgRef.current.focus();
        }
    }, [messages, firstMsgRef.current]);

    return (
        <ul className="error-message-list">
            {msgElements}
        </ul>
    )
}

export default ErrorMessageList;
